module.exports = __webpack_public_path__ + "img/SES_235280004.ceb663f7.jpg";